import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input
} from '@lockerpm/design';

import {
  InfoCircleFilled
} from "@ant-design/icons";

import { } from 'react-redux';

import {
} from '../../../../../utils/common';

import { useTranslation } from "react-i18next";

import global from "../../../../../config/global";
import accessKeyServices from "../../../../../services/access-key";

const DeleteModal = (props) => {
  const { t } = useTranslation()
  const {
    visible = false,
    item = {},
    currentPage = {},
    onClose = () => {},
    onReload = () => {}
  } = props;
  const [form] = Form.useForm();
  const [callingAPI, setCallingAPI] = useState(false);
  const accessKeyID = Form.useWatch('accessKeyID', form);

  useEffect(() => {
    form.resetFields()
  }, [visible])

  const handleDelete = async () => {
    form.validateFields().then(async () => {
      setCallingAPI(true)
      accessKeyServices.remove(currentPage.params?.project_id, item.id).then(async () => {
        global.pushSuccess(t('notification.success.access_key.deleted'));
        onClose();
        onReload();
      }).catch((error) => {
        global.pushError(error)
      });
      setCallingAPI(false);
    })
  }

  return (
    <Modal
      title={
        <div className="flex items-center gap-3">
          <InfoCircleFilled className="text-warning text-xl"/>
          <p>
            {t('access_key.delete')}
          </p>
        </div>
      }
      open={visible}
      width={360}
      okText={t('button.delete')}
      onOk={() => handleDelete()}
      onCancel={() => onClose()}
      okButtonProps={{
        loading: callingAPI,
        disabled: !accessKeyID || accessKeyID !== item?.id
      }}
      cancelButtonProps={{
        disabled: callingAPI
      }}
    >
      <p>
        {t('access_key.enter_id')}
      </p>
      <p className="mb-2">
        {t('access_key.id')}: <b>{item?.id}</b>
      </p>
      <Form
        form={form}
        onFinish={handleDelete}
      >
        <Form.Item
          name={'accessKeyID'}
          rules={[
            global.rules.REQUIRED(t('auth_pages.password')),
          ]}
        >
          <Input.Password
            autoFocus={true}
            placeholder={t('placeholder.enter')}
            disabled={callingAPI}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default DeleteModal;